import { z } from 'zod';
import { pageParam, pageSizeParam } from '../_shared/coerce.js';
const ESTIMATE_TYPE_FILTERS = ['ALL', 'FLIGHT', 'TOURISM'];
const ESTIMATE_TAB_STATUSES = [
    'ALL',
    'PENDING',
    'AWAITING_RESPONSE',
    'RESERVATION_PENDING',
    'COMPLETED',
    'EXPIRED',
    'POUR_PLUS_TARD',
    'DECLINED',
    'DECLINED_HANDLED',
    'MODIFICATION_REQUESTED',
    'MODIFICATION_HANDLED',
];
const TRAVEL_TYPE_FILTERS = [
    'ALL',
    'ONE_WAY',
    'ROUND_TRIP',
    'MULTI_DESTINATION',
    'CRUISE',
    'STAY',
    'TOUR',
];
/**
 * PPT — rangement/sortie manuels de « Pour plus tard ». `notifyClient` déclenche
 * la notification tarifaire (56 au rangement, 55 à la sortie), idempotente par
 * devis.
 */
export const setEstimateSnoozedSchema = z.object({
    notifyClient: z.boolean().optional().default(false),
    snoozed: z.boolean(),
});
/** Bouton « Traité » des refus et demandes de modification. */
export const setClientAnswerHandledSchema = z.object({
    handled: z.boolean(),
});
/**
 * Pastilles de l'onglet « Propositions ». `ALL` d'abord, puis les huit statuts
 * de `ProposalListStatus` — le même vocabulaire que partout ailleurs.
 */
export const PROPOSAL_LIST_TABS = [
    'ALL',
    'SAVED',
    'AWAITING_CLIENT',
    'MODIFICATION_REQUESTED',
    'RESERVATION_REQUESTED',
    'CONFIRMED',
    'DECLINED',
    'DECLINED_AUTO',
    'EXPIRED',
];
/**
 * Tris de la liste des propositions. `sentAt` est le défaut : la question posée
 * est « qu'est-ce qui est parti en dernier ». Les propositions jamais envoyées
 * s'y rangent sur leur date de création, faute de mieux.
 */
export const PROPOSAL_SORT_FIELDS = ['sentAt', 'validTo', 'totalPrice', 'createdAt'];
export const getProposalsQuerySchema = z.object({
    agency: z.enum(['ALL', 'MRS', 'RUN']).optional(),
    /** Agent qui a rédigé la proposition, pas celui qui a reçu la demande. */
    author: z.string().optional(),
    estimateType: z.enum(ESTIMATE_TYPE_FILTERS).optional().default('ALL'),
    page: pageParam(),
    pageSize: pageSizeParam(),
    search: z.string().optional(),
    sortBy: z.enum(PROPOSAL_SORT_FIELDS).optional().default('sentAt'),
    sortOrder: z.enum(['asc', 'desc']).optional().default('desc'),
    tab: z.enum(PROPOSAL_LIST_TABS).optional().default('ALL'),
    travelType: z.enum(TRAVEL_TYPE_FILTERS).optional().default('ALL'),
});
export const getEstimatesQuerySchema = z.object({
    clientId: z.string().optional(),
    agency: z.enum(['ALL', 'MRS', 'RUN']).optional(),
    estimateType: z.enum(ESTIMATE_TYPE_FILTERS).optional().default('ALL'),
    page: pageParam(),
    pageSize: pageSizeParam(),
    search: z.string().optional(),
    sortBy: z.enum(['createdAt', 'departureDate', 'returnDate']).optional(),
    sortOrder: z.enum(['asc', 'desc']).optional(),
    tab: z.enum(ESTIMATE_TAB_STATUSES).optional().default('ALL'),
    travelType: z.enum(TRAVEL_TYPE_FILTERS).optional().default('ALL'),
});
